/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BarChart, LineChart, PieChart} from '../../../components/Charts';
export const globalData = {
  population: '7.84 billion (in 2021)',
  laborForce: '3.45 billion (in 2021)',
  unemploymentRate: '5.9%',
  gdpPerCapita: '16,300 US dollars'
};
export const apparelMarketData = [{
  year: '2019',
  value: 1773406.9
}, {
  year: '2020',
  value: 1453277.5
}, {
  year: '2021',
  value: 1716952.2
}, {
  year: '2022',
  value: 1846222,
  forecast: true
}, {
  year: '2023',
  value: 1959592.1,
  forecast: true
}];
export const marketGrowthData = [{
  period: '2019-2020',
  growth: -18.1
}, {
  period: '2020-2021',
  growth: 18.1
}, {
  period: '2021-2022',
  growth: 7.5,
  forecast: true
}, {
  period: '2022-2023',
  growth: 6.1,
  forecast: true
}];
export const largestMarketsData = [{
  name: 'China',
  value: 427153.9
}, {
  name: 'USA',
  value: 364136.6
}, {
  name: 'United Kingdom',
  value: 70734.8
}, {
  name: 'Germany',
  value: 69957.3
}, {
  name: 'Japan',
  value: 65764
}];
export const apparelSegmentsData = [{
  name: 'Womenswear',
  value: 53
}, {
  name: 'Menswear',
  value: 31
}, {
  name: 'Childrenswear',
  value: 16
}];
export const textileExportersData = [{
  name: 'China',
  value: 154,
  share: 43.5
}, {
  name: 'European Union',
  value: 64,
  share: 18.1
}, {
  name: 'India',
  value: 15,
  share: 4.2
}, {
  name: 'Turkey',
  value: 12,
  share: 3.3
}, {
  name: 'USA',
  value: 11,
  share: 3.2
}];
export const textileImportersData = [{
  name: 'European Union',
  value: 87,
  share: 24.3
}, {
  name: 'USA',
  value: 45,
  share: 12.6
}, {
  name: 'Vietnam',
  value: 16,
  share: 4.4
}, {
  name: 'China',
  value: 14,
  share: 3.9
}, {
  name: 'Japan',
  value: 12,
  share: 3.3
}];
export const clothingExportersData = [{
  name: 'China',
  value: 142,
  share: 31.6
}, {
  name: 'European Union',
  value: 125,
  share: 27.9
}, {
  name: 'Vietnam',
  value: 29,
  share: 6.4
}, {
  name: 'Bangladesh',
  value: 28,
  share: 6.3
}, {
  name: 'Turkey',
  value: 15,
  share: 3.4
}];
export const clothingImportersData = [{
  name: 'European Union',
  value: 168,
  share: 34.1
}, {
  name: 'USA',
  value: 86,
  share: 16.8
}, {
  name: 'Japan',
  value: 82,
  share: 5.3
}, {
  name: 'United Kingdom',
  value: 26,
  share: 5.3
}, {
  name: 'Canada',
  value: 10,
  share: 2.1
}];
export const brandValueData = [{
  name: 'Nike',
  value: 30.4
}, {
  name: 'Gucci',
  value: 15.6
}, {
  name: 'Louis Vuitton',
  value: 14.8
}, {
  name: 'Adidas',
  value: 14.3
}, {
  name: 'Chanel',
  value: 13.2
}, {
  name: 'Zara',
  value: 13.1
}, {
  name: 'Uniqlo',
  value: 13.0
}, {
  name: 'H&M',
  value: 12.3
}];
export const marketCapData = [{
  name: 'LVMH Group',
  value: 367
}, {
  name: 'Nike',
  value: 216
}, {
  name: 'Dior',
  value: 124
}, {
  name: 'Inditex',
  value: 81
}, {
  name: 'TJX Companies',
  value: 79
}];
export const ecommerceGrowthData = [{
  year: '2020',
  value: 4.2
}, {
  year: '2021',
  value: 4.9
}, {
  year: '2022',
  value: 5.5,
  forecast: true
}, {
  year: '2025',
  value: 7,
  forecast: true
}];
export const ecommercePercentageData = [{
  year: '2020',
  value: 17.8
}, {
  year: '2021',
  value: 19.6
}, {
  year: '2022',
  value: 21,
  forecast: true
}, {
  year: '2025',
  value: 24.5,
  forecast: true
}];
export const fashionEcommerceData = [{
  year: '2021',
  value: 668.1
}, {
  year: '2022',
  value: 744.4,
  forecast: true
}, {
  year: '2025',
  value: 1200,
  forecast: true
}];
export const ecommerceSegmentsData = [{
  name: 'Accessories',
  value: 261.5
}, {
  name: 'Footwear',
  value: 122
}, {
  name: 'Other Apparel',
  value: 284.6
}];
export const consumptionData = [{
  year: '2019',
  units: 17.2,
  spend: 232.7
}, {
  year: '2020',
  units: 15.4,
  spend: 186.6
}, {
  year: '2021',
  units: 16.7,
  spend: 220.7
}, {
  year: '2022',
  units: 17.2,
  spend: 235.2,
  forecast: true
}, {
  year: '2023',
  units: 17.6,
  spend: 247.4,
  forecast: true
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    h3: "h3",
    p: "p",
    a: "a",
    em: "em",
    ul: "ul",
    li: "li",
    hr: "hr"
  }, _provideComponents(), props.components), {ChartGrid} = _components;
  if (!ChartGrid) _missingMdxReference("ChartGrid", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "General data"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Population:"
            })
          }), _jsx(_components.td, {
            children: "7.84 billion (in 2021) Source: World Bank Open Data, July 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Labor force:"
            })
          }), _jsx(_components.td, {
            children: "3.45 billion (in 2021) Source: World Bank Open Data, 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Unemployment rate:"
            })
          }), _jsx(_components.td, {
            children: "5.9% *2022 global estimate. Source: International Labour Organization (Ilostat)"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "GDP per capita (PPP):"
            })
          }), _jsx(_components.td, {
            children: "16,300 US dollars 12,262.9 US$ (in 2021). Source: World Bank Open Data, July 2022"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "The United States and China: largest economies and the largest apparel retail markets in the world"
    }), "\n", _jsx(_components.p, {
      children: "The ten largest economies in the world as measured by nominal GDP are the United\nStates , China, Japan, Germany, United Kingdom, India, France, Italy, Canada\nand South Korea."
    }), "\n", _jsx(_components.p, {
      children: "The US accounts for 24.67% of the total global economy, China has a share of 17.39%, Japan a share of 5.97%, Germany a share of 4.54% and the UK makes up 3.26%."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Investopedia article, based on The World Bank data GDP 2020. Last updated in June, 2022 ."
      })
    }), "\n", _jsx(_components.p, {
      children: "The largest retail markets in the world are China, the US, the United Kingdom, Germany and Japan (more about that in the next paragraph 'The Global Apparel Market)."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "In 2021. Source: Euromonitor International, a market research provider"
      })
    }), "\n", _jsx(_components.p, {
      children: "China and the US also play a significant role in international trade. China is the largest exporter worldwide of clothing and the US is second largest importer (more about that in the paragraph 'Trade Textiles & Clothing Worldwide: Export & Import')."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Statista, March 2022 & World Trade Statistical Review 2021 Report, from the World Trade Organization (WTO)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "The Global Apparel Market"
    }), "\n", _jsx("strong", {
      children: "Fashion is one of the biggest industries in the world"
    }), "\n", _jsx(_components.p, {
      children: "\"Fashion is one of the world's most important industries, driving a significant part of the global economy. It is one of the key value-creating industries for the world economy. If it were ranked alongside individual countries' GDP the global fashion industry would represent the seventh-largest economy in the world,'' stated McKinsey in its State of Fashion 2017 report."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: McKinsey State of Fashion 2017 report, McKinsey & BoF, in 2016."
      })
    }), "\n", _jsx("strong", {
      children: "Revenue: $1.7 trillion dollar industry (2021)"
    }), "\n", _jsx(_components.p, {
      children: "Before the Covid-19 pandemic, the fashion industry global revenue was estimated between $1.7 trillion and $2.5 trillion according to two different research reports by Euromonitor and McKinsey."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Euromonitor International, a market research provider & McKinsey report 'State of Fashion 2022: An uneven recovery and new frontiers'. Source: McKinsey analysis 2019"
      })
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: apparelMarketData,
        dataKey: "value",
        xAxisKey: "year",
        title: "Worldwide Apparel & Footwear Market Size",
        subtitle: "Retail Value RSP USD trillion",
        source: "Euromonitor International",
        valuePrefix: "$",
        valueSuffix: "T",
        valueLabel: "Market Size",
        valueScale: 1000000,
        height: 450,
        color: "#8884d8"
      }), _jsx(LineChart, {
        data: marketGrowthData,
        dataKey: "growth",
        xAxisKey: "period",
        title: "Worldwide Apparel & Footwear Market Growth",
        subtitle: "Year on year growth (%)",
        source: "Euromonitor International",
        valueSuffix: "%",
        valueLabel: "Growth Rate",
        yDomain: [-20, 20],
        color: "#82ca9d"
      })]
    }), "\n", _jsx("strong", {
      children: "The Covid-19 pandemic has affected the fashion industry"
    }), "\n", _jsx(_components.p, {
      children: "According to Euromonitor the global apparel and footwear market size shrunk in 2020 by -18.1% (to $1.45 trillion), while McKinsey states that the fashion and apparel industry suffered a 20% decline in revenues for the 2019-2020 fiscal year."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Euromonitor, June 2021 & McKinsey report State of Fashion 2022: An uneven recovery and new frontier, December 2021"
      })
    }), "\n", _jsx("strong", {
      children: "Post-Covid-19 Retail: Revenge Shopping"
    }), "\n", _jsx(_components.p, {
      children: "After lockdown restrictions were lifted in many parts of the world, consumers headed back to the stores. With that the fashion industry returned to pre-pandemic levels."
    }), "\n", _jsx(_components.p, {
      children: "According to Euromonitor, the global apparel and footwear industry grew by 18.1% at current prices in 2020-2021, to $1.71 billion dollars in market size (retail value USD million) in 2021."
    }), "\n", _jsx(_components.p, {
      children: "The world's apparel retail market is expected to enjoy a 7.5% growth in 2021-2022 to $1.84 billion dollars in 2022 and a 6.1% growth in 2022-2023 to $1.95 billion dollars in 2023."
    }), "\n", _jsxs(_components.p, {
      children: ["Source: ", _jsx(_components.a, {
        href: "https://fashionunited.com/companies/euromonitor-international",
        children: "Euromonitor International, a market research provider"
      })]
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: largestMarketsData,
        dataKey: "value",
        xAxisKey: "name",
        title: "Largest Apparel and Footwear Markets Worldwide (2021)",
        subtitle: "Market Size in USD billion",
        source: "Euromonitor International",
        valuePrefix: "$",
        valueSuffix: "B",
        valueLabel: "Market Size",
        valueScale: 100000,
        color: "#ff7300"
      }), _jsx(PieChart, {
        data: apparelSegmentsData,
        dataKey: "value",
        nameKey: "name",
        title: "Global Apparel Market Segments (2018)",
        subtitle: "Share of global fashion retail spending",
        source: "Euromonitor International via Common Objective",
        valueSuffix: "%",
        valueLabel: "Market Share",
        colors: ['#FF6B8A', '#5DA5DA', '#FAA43A']
      })]
    }), "\n", _jsx("strong", {
      children: "Key Apparel Markets"
    }), "\n", _jsx(_components.p, {
      children: "Revenue generated from the women's apparel market is much higher than that of men's or children's apparel. In 2018, womenswear made up more than half (53%) of global fashion retail spending. Spending on menswear accounted for 31% and childrenswear for 16%."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "States Common Objective in article in 2018, based on data from Market research provider, Euromonitor International."
      })
    }), "\n", _jsx(_components.h2, {
      children: "Trade Textiles & Clothing Worldwide: Export & Import"
    }), "\n", _jsx(_components.p, {
      children: "World merchandise exports of manufactured goods were affected by the Covid-19 pandemic in 2020: the annual percentage change was -5.2% in total. Clothing saw a -9.1% decline in 2020, while textiles saw a strong increase of +16%, due to the demand for protective personal equipment."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "*WTO estimates. Source: World Trade Statistical Review 2021 Report, from the World Trade Organization (WTO)"
      })
    }), "\n", _jsx("strong", {
      children: "China is the largest exporter of textiles and clothing worldwide and the EU is the largest importer of these goods"
    }), "\n", _jsx(_components.p, {
      children: "More detailed information in the table below."
    }), "\n", _jsx("strong", {
      children: "Top 10 exporters and importers of TEXTILES, 2020"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Country"
          }), _jsx(_components.th, {
            children: "Value 2020 billion dollars"
          }), _jsx(_components.th, {
            children: "Share in world exports/imports 2020"
          }), _jsx(_components.th, {
            children: "Annual percentage change 2020"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx("b", {
              children: "Exporters"
            })
          }), _jsx(_components.td, {}), _jsx(_components.td, {}), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "China (1)"
          }), _jsx(_components.td, {
            children: "154"
          }), _jsx(_components.td, {
            children: "43.5"
          }), _jsx(_components.td, {
            children: "29"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "European Union"
          }), _jsx(_components.td, {
            children: "64"
          }), _jsx(_components.td, {
            children: "18.1"
          }), _jsx(_components.td, {
            children: "-3"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "India"
          }), _jsx(_components.td, {
            children: "15"
          }), _jsx(_components.td, {
            children: "4.2"
          }), _jsx(_components.td, {
            children: "-12"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Turkey"
          }), _jsx(_components.td, {
            children: "12"
          }), _jsx(_components.td, {
            children: "3.3"
          }), _jsx(_components.td, {
            children: "-1"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "United States of America"
          }), _jsx(_components.td, {
            children: "11"
          }), _jsx(_components.td, {
            children: "3.2"
          }), _jsx(_components.td, {
            children: "-15"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Vietnam"
          }), _jsx(_components.td, {
            children: "10"
          }), _jsx(_components.td, {
            children: "2.8"
          }), _jsx(_components.td, {
            children: "11"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Korea, Republic of"
          }), _jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: "2.2"
          }), _jsx(_components.td, {
            children: "-15"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Pakistan"
          }), _jsx(_components.td, {
            children: "7"
          }), _jsx(_components.td, {
            children: "2.0"
          }), _jsx(_components.td, {
            children: "-8"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Chinese Taipei"
          }), _jsx(_components.td, {
            children: "7"
          }), _jsx(_components.td, {
            children: "2.0"
          }), _jsx(_components.td, {
            children: "-17"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Japan"
          }), _jsx(_components.td, {
            children: "6"
          }), _jsx(_components.td, {
            children: "1.6"
          }), _jsx(_components.td, {
            children: "-14"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx("b", {
              children: "Importers"
            })
          }), _jsx(_components.td, {}), _jsx(_components.td, {}), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "European Union"
          }), _jsx(_components.td, {
            children: "87"
          }), _jsx(_components.td, {
            children: "24.3"
          }), _jsx(_components.td, {
            children: "29"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "United States of America"
          }), _jsx(_components.td, {
            children: "45"
          }), _jsx(_components.td, {
            children: "12.6"
          }), _jsx(_components.td, {
            children: "44"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Vietnam"
          }), _jsx(_components.td, {
            children: "16"
          }), _jsx(_components.td, {
            children: "4.4"
          }), _jsx(_components.td, {
            children: "-8"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "China"
          }), _jsx(_components.td, {
            children: "14"
          }), _jsx(_components.td, {
            children: "3.9"
          }), _jsx(_components.td, {
            children: "-10"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Japan"
          }), _jsx(_components.td, {
            children: "12"
          }), _jsx(_components.td, {
            children: "3.3"
          }), _jsx(_components.td, {
            children: "34"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "United Kingdom"
          }), _jsx(_components.td, {
            children: "11"
          }), _jsx(_components.td, {
            children: "3.0"
          }), _jsx(_components.td, {
            children: "52"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Bangladesh"
          }), _jsx(_components.td, {
            children: "9"
          }), _jsx(_components.td, {
            children: "2.5"
          }), _jsx(_components.td, {
            children: "-17"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Canada"
          }), _jsx(_components.td, {
            children: "6"
          }), _jsx(_components.td, {
            children: "1.8"
          }), _jsx(_components.td, {
            children: "41"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Korea, Republic of"
          }), _jsx(_components.td, {
            children: "6"
          }), _jsx(_components.td, {
            children: "1.6"
          }), _jsx(_components.td, {
            children: "9"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Indonesia"
          }), _jsx(_components.td, {
            children: "5"
          }), _jsx(_components.td, {
            children: "1.5"
          }), _jsx(_components.td, {
            children: "-21"
          })]
        })]
      })]
    }), "\n", _jsx("strong", {
      children: "Top 10 exporters and importers of CLOTHING, 2020"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Country"
          }), _jsx(_components.th, {
            children: "Value 2020 billion dollars"
          }), _jsx(_components.th, {
            children: "Share in world exports/imports 2020"
          }), _jsx(_components.th, {
            children: "Annual percentage change 2020"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx("b", {
              children: "Exporters"
            })
          }), _jsx(_components.td, {}), _jsx(_components.td, {}), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "China (1)"
          }), _jsx(_components.td, {
            children: "142"
          }), _jsx(_components.td, {
            children: "31.6"
          }), _jsx(_components.td, {
            children: "-7"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "European Union"
          }), _jsx(_components.td, {
            children: "125"
          }), _jsx(_components.td, {
            children: "27.9"
          }), _jsx(_components.td, {
            children: "-8"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Vietnam"
          }), _jsx(_components.td, {
            children: "29"
          }), _jsx(_components.td, {
            children: "6.4"
          }), _jsx(_components.td, {
            children: "-7"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Bangladesh"
          }), _jsx(_components.td, {
            children: "28"
          }), _jsx(_components.td, {
            children: "6.3"
          }), _jsx(_components.td, {
            children: "-15"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Turkey"
          }), _jsx(_components.td, {
            children: "15"
          }), _jsx(_components.td, {
            children: "3.4"
          }), _jsx(_components.td, {
            children: "-6"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "India"
          }), _jsx(_components.td, {
            children: "13"
          }), _jsx(_components.td, {
            children: "2.9"
          }), _jsx(_components.td, {
            children: "-24"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Malaysia"
          }), _jsx(_components.td, {
            children: "10"
          }), _jsx(_components.td, {
            children: "2.2"
          }), _jsx(_components.td, {
            children: "73"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "United Kingdom"
          }), _jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: "1.9"
          }), _jsx(_components.td, {
            children: "-7"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Hong Kong, China"
          }), _jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: "…"
          }), _jsx(_components.td, {
            children: "-33"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Indonesia"
          }), _jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: "1.7"
          }), _jsx(_components.td, {
            children: "-12"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx("b", {
              children: "Importers"
            })
          }), _jsx(_components.td, {}), _jsx(_components.td, {}), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "European Union"
          }), _jsx(_components.td, {
            children: "168"
          }), _jsx(_components.td, {
            children: "34.1"
          }), _jsx(_components.td, {
            children: "-7"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "United States of America"
          }), _jsx(_components.td, {
            children: "86"
          }), _jsx(_components.td, {
            children: "16.8"
          }), _jsx(_components.td, {
            children: "-14"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Japan"
          }), _jsx(_components.td, {
            children: "82"
          }), _jsx(_components.td, {
            children: "5.3"
          }), _jsx(_components.td, {
            children: "-12"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "United Kingdom"
          }), _jsx(_components.td, {
            children: "26"
          }), _jsx(_components.td, {
            children: "5.3"
          }), _jsx(_components.td, {
            children: "-1"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Canada"
          }), _jsx(_components.td, {
            children: "10"
          }), _jsx(_components.td, {
            children: "2.1"
          }), _jsx(_components.td, {
            children: "-6"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Korea, Republic of"
          }), _jsx(_components.td, {
            children: "10"
          }), _jsx(_components.td, {
            children: "2.0"
          }), _jsx(_components.td, {
            children: "-12"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "China"
          }), _jsx(_components.td, {
            children: "9"
          }), _jsx(_components.td, {
            children: "1.9"
          }), _jsx(_components.td, {
            children: "6"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Switzerland"
          }), _jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: "1.6"
          }), _jsx(_components.td, {
            children: "4"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Hong Kong, China"
          }), _jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: "…"
          }), _jsx(_components.td, {
            children: "-31"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Russian Federation"
          }), _jsx(_components.td, {
            children: "8"
          }), _jsx(_components.td, {
            children: "1.6"
          }), _jsx(_components.td, {
            children: "-5"
          })]
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "More detailed information in the charts below."
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: textileExportersData,
        dataKey: "value",
        xAxisKey: "name",
        title: "Top 5 Exporters of Textiles (2020)",
        subtitle: "Value in billion dollars",
        source: "World Trade Statistical Review 2021 Report, WTO",
        valuePrefix: "$",
        valueSuffix: "B",
        valueLabel: "Export Value",
        color: "#8884d8"
      }), _jsx(BarChart, {
        data: textileImportersData,
        dataKey: "value",
        xAxisKey: "name",
        title: "Top 5 Importers of Textiles (2020)",
        subtitle: "Value in billion dollars",
        source: "World Trade Statistical Review 2021 Report, WTO",
        valuePrefix: "$",
        valueSuffix: "B",
        valueLabel: "Import Value",
        color: "#82ca9d"
      })]
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: clothingExportersData,
        dataKey: "value",
        xAxisKey: "name",
        title: "Top 5 Exporters of Clothing (2020)",
        subtitle: "Value in billion dollars",
        source: "World Trade Statistical Review 2021 Report, WTO",
        valuePrefix: "$",
        valueSuffix: "B",
        valueLabel: "Export Value",
        color: "#ff7300"
      }), _jsx(BarChart, {
        data: clothingImportersData,
        dataKey: "value",
        xAxisKey: "name",
        title: "Top 5 Importers of Clothing (2020)",
        subtitle: "Value in billion dollars",
        source: "World Trade Statistical Review 2021 Report, WTO",
        valuePrefix: "$",
        valueSuffix: "B",
        valueLabel: "Import Value",
        color: "#00C49F"
      })]
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: World Trade Statistical Review 2021 Report, from the World Trade Organization (WTO)"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Fashion Companies"
    }), "\n", _jsx(_components.p, {
      children: "To cater to the large, 3,000 billion, textile and garment industry new companies are entering the market every day. Most of these companies remain rather unknown to the consumer audience, better known are the individual brands that are part of these global fashion companies."
    }), "\n", _jsx("strong", {
      children: "Leading clothing companies worldwide by market capitalization (2022)"
    }), "\n", _jsx(_components.p, {
      children: "In March 2022, The LVMH Group was by far the clothing company with the highest market capitalization, at approximately $367 billion dollars. This was over 150 billion dollars more than Nike, the company in second place, with a market cap of $216 billion dollars. Dior came in third with a market cap of $124 billion dollars, followed by Inditex with a market cap of $81 billion dollars, TJX Companies with a market cap of $79 billion dollars, Fast Retailing with a market cap of $55 billion dollars, Adidas with a market cap of $45 billion dollars, Lululemon Athletica with a market cap of $41 billion dollars, Ross Stores with a market cap of $32 billion dollars and H&M closes the top ten with a market cap of $27 billion dollars."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Statista, Clothing companies with the greatest market capitalization worldwide as of March 2022, March 2022"
      })
    }), "\n", _jsx("strong", {
      children: "Leading clothing companies with the highest brand value (2021)"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://fashionunited.com/news/fashion/nike-is-world-s-top-valuable-apparel-brand/2021040839336",
        children: "Sportswear giant Nike claimed the title of the world's \"most valuable\" apparel brand for the seventh year in 2021"
      }), ". Nike maintains a considerable lead over Gucci in second place, which has a brand value of 15.6 billion dollars, down 12 percent from 2020. Its noteworthy that the total value of the world's top 50 most valuable apparel brands has declined by 8% as the sector negotiates fallout from Covid-19 pandemic."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://fashionunited.com/news/fashion/nike-is-world-s-top-valuable-apparel-brand/2021040839336",
        children: "Coach is the sector's fastest falling brand, brand value down 31 percent. Rolex is world's strongest apparel brand"
      }), "."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Brand"
          }), _jsx(_components.th, {
            children: "Brand value US$"
          }), _jsx(_components.th, {
            children: "%"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Nike"
          }), _jsx(_components.td, {
            children: "30.4 billion"
          }), _jsx(_components.td, {
            children: "-12,5%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Gucci"
          }), _jsx(_components.td, {
            children: "15.6 billion"
          }), _jsx(_components.td, {
            children: "-11,5%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Louis Vuitton"
          }), _jsx(_components.td, {
            children: "14.8 billion"
          }), _jsx(_components.td, {
            children: "-9.8%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Adidas"
          }), _jsx(_components.td, {
            children: "14.3 billion"
          }), _jsx(_components.td, {
            children: "-13%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Chanel"
          }), _jsx(_components.td, {
            children: "13,2 billion"
          }), _jsx(_components.td, {
            children: "-3.4%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Zara"
          }), _jsx(_components.td, {
            children: "13,1 billion"
          }), _jsx(_components.td, {
            children: "-9.8%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Uniqlo"
          }), _jsx(_components.td, {
            children: "13,0 billion"
          }), _jsx(_components.td, {
            children: "+1,5%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "H&M"
          }), _jsx(_components.td, {
            children: "12,3 billion"
          }), _jsx(_components.td, {
            children: "-10.8%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Cartier"
          }), _jsx(_components.td, {
            children: "12,0 billion"
          }), _jsx(_components.td, {
            children: "-19.5%"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Hermes"
          }), _jsx(_components.td, {
            children: "11,6 billion"
          }), _jsx(_components.td, {
            children: "-2.1%"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Source: ", _jsx(_components.a, {
        href: "https://brandfinance.com/press-releases/nike-does-it-again-claiming-title-of-worlds-most-valuable-apparel-brand-for-7th-consecutive-year",
        children: "the Brand Finance Apparel 50 2021 report, April 2021."
      })]
    }), "\n", _jsx("strong", {
      children: "The World's Most Valuable Brands (2020)"
    }), "\n", _jsx(_components.p, {
      children: "Louis Vuitton is ranked the best performing fashion brand on position 9 of all brands (not only fashion) worldwide with a brand value of $47.2 billion dollars. Nike comes second, number 13 worldwide, with a brand value of $39.1 billion. Other fashion brands/companies in the Top 50 of valuable brands are Gucci on position 31 with a brand value of $22.6 billion, Hermès at number 32 with a brand value of $21.6 billion, and Zara on position 41 with a brand value of $14.7 billion. On position 51 you find Adidas with a brand value of $12.9 billion, followed by Chanel on 52 with a brand value of $12.8 billion. H&M is on position 76 with a brand value of $10.4 billion and Uniqlo on 84 with a brand value of $9.2 billion."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Forbes' 2020 list of the World's Most Valuable Brands—which looks at the top 100 companies from fiscal year 2019"
      })
    }), "\n", _jsx("strong", {
      children: "Fashion's hottest brands (Q1 2022): Gucci & Balenciaga"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://fashionunited.com/news/fashion/lyst-index-balenciaga-retains-title-of-fashion-s-hottest-brand/2022042947338",
        children: "Spanish luxury fashion house Balenciaga has retained its spot as the hottest brand on the planet in the first quarter of 2022 according to the latest Lyst Index"
      }), ". Another stable name was that of Italian luxury brand Gucci, which was again in second place in the first quarter of the year. French label Louis Vuitton moved up one spot to third place. In this same quarter the brand presented its final show by late menswear fashion director Virgil Abloh. The 17 hottest brands in the top 20 were Prada, Valentino, Dior, Moncler, Bottega Veneta, Fendi, Miu Miu, Off White, Burberry, Loewe, Versace, Diesel, Rick Owens, Adidas, Saint Laurent, Nike, and Alexander McQueen."]
    }), "\n", _jsxs(_components.p, {
      children: ["Source: ", _jsx(_components.a, {
        href: "https://fashionunited.com/news/fashion/lyst-index-balenciaga-retains-title-of-fashion-s-hottest-brand/2022042947338",
        children: "Lyst Index"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Labor Force"
    }), "\n", _jsx(_components.p, {
      children: "The clothing, textile and footwear industries together are incredibly labour-intensive."
    }), "\n", _jsx(_components.p, {
      children: "Different sources name various numbers when estimating the amount of people that work in the garment industry. According to the International Labour Organisation, there are more than 60 million workers around the globe in the textiles, clothing, leather and footwear industries. This implies that this number is limited to people that work in textile and apparel production.The Ellen MacArthur Foundation states that globally, the clothing industry employs more than 300 million people along the value chain, which can be understood to also include people that work in design, distribution and retail divisions of the fashion industry."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Ellen MacArthur Foundation &  International Labour Organisation, 2019"
      })
    }), "\n", _jsx(_components.p, {
      children: "In Europe, there are 1.3 million people employed in the textile and clothing industry at 143,000 companies. 537,482 people work in textiles and 760,637 in clothing."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "*2021 estimates. Source: Report Facts & Key figures 2022 of the European\nTextile and Clothing Industry by Euratex, June 2022."
      })
    }), "\n", _jsx(_components.h2, {
      children: "Global apparel production & consumption"
    }), "\n", _jsx("strong", {
      children: "Production"
    }), "\n", _jsx(_components.p, {
      children: "The global fashion industry produces more than 100 to 150 billion items of clothing per year."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Sources: more than 100 billion according to McKinsey & the Ellen\nMacArthur Foundation. The World Economic Forum & ShareCloth state that 150\nbillion garments are produced in a year."
      })
    }), "\n", _jsx(_components.p, {
      children: "The number of garments produced annually has doubled since 2000 and exceeded 100 billion for the first time in 2014."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: McKinsey, article 'Style that's sutainable: A new fast-fashion formula, October 2016."
      })
    }), "\n", _jsx("strong", {
      children: "Global apparel consumption: How many new clothes are bought each year?"
    }), "\n", _jsx(_components.p, {
      children: "Clothing consumption has grown explosively over the past 20 years. Fashion consumers buy over 80 billion new pieces of clothing every year. This is over 400% more than what we consumed just two decades ago."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: website True Cost, a documentary film exploring the impact of fashion on people and the planet that was released in 2015."
      })
    }), "\n", _jsx(_components.p, {
      children: "In 2016 approximately 107 billion units of apparel and 14.5 billion pairs of shoes were purchased worldwide. That amounts to every single individual on the planet buying roughly 13 garments and 2 pairs of shoes every year."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "In an article from Common Objective CO Data 'Volume and Consumption: How\nMuch Does The World Buy?', May 2018. Based on data from Euromonitor International"
      })
    }), "\n", _jsx(_components.p, {
      children: "If that seems like a lot, then keep in mind that this number also includes millions of people in extreme poverty who struggle to make ends meet, let alone buy any new clothes. Then you start to realise that in reality a far smaller amount of people are actually buying much, much more."
    }), "\n", _jsx(_components.p, {
      children: "In 2021, people consumed 16.7 units of apparel & footwear on average worldwide, spending $220,7 dollars on average."
    }), "\n", _jsx(LineChart, {
      data: consumptionData,
      dataKey: "units",
      xAxisKey: "year",
      title: "Worldwide Consumption Apparel & Footwear",
      subtitle: "Units per capita (retail volume)",
      source: "Euromonitor International",
      valueLabel: "Units per capita",
      color: "#FF8042"
    }), "\n", _jsx("strong", {
      children: "Which countries consume the most?"
    }), "\n", _jsx(_components.p, {
      children: "Number of apparel units purchased per country in 2017: China (40 billion units), the US (17 billion), India (6 billion), Japan (3.3 billion), Brazil (2.3 billion), Germany (2.2 billion), UK (2.1 billion), Russia (2 billion), France (1.5 billion) and Italy (1.3 billion).\nThe rest of the world consumed 26 billion units in 2017."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Common Objective CO Data in the article 'Volume and Consumption: How Much Does The World Buy?', May 2018. Based on data: 'Number of apparel units purchased per country, 2017 from Market Research Provider, Euromonitor International."
      })
    }), "\n", _jsx(_components.p, {
      children: "(You find the 5 markets with the highest market size in 2021 in USD million in the second paragraph 'The Global Apparel Market')"
    }), "\n", _jsx("strong", {
      children: "Apparel consumer purchasing habits across the globe"
    }), "\n", _jsx(_components.p, {
      children: "Which country spends the most on clothes? How many new items are purchased per person? What is the average value per item?"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Country"
          }), _jsx(_components.th, {
            children: "Value spent per person"
          }), _jsx(_components.th, {
            children: "Items purchased per person"
          }), _jsx(_components.th, {
            children: "Average value per item"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "USA"
          }), _jsx(_components.td, {
            children: "$844"
          }), _jsx(_components.td, {
            children: "53"
          }), _jsx(_components.td, {
            children: "$16.04"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "UK"
          }), _jsx(_components.td, {
            children: "$889"
          }), _jsx(_components.td, {
            children: "33"
          }), _jsx(_components.td, {
            children: "$27.33"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Brazil"
          }), _jsx(_components.td, {
            children: "$117"
          }), _jsx(_components.td, {
            children: "11"
          }), _jsx(_components.td, {
            children: "$10.49"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Norway"
          }), _jsx(_components.td, {
            children: "$1150"
          }), _jsx(_components.td, {
            children: "12"
          }), _jsx(_components.td, {
            children: "$28.26"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Egypt"
          }), _jsx(_components.td, {
            children: "$27"
          }), _jsx(_components.td, {
            children: "2"
          }), _jsx(_components.td, {
            children: "$12.63"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "India"
          }), _jsx(_components.td, {
            children: "$34"
          }), _jsx(_components.td, {
            children: "5"
          }), _jsx(_components.td, {
            children: "$7.01"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "China"
          }), _jsx(_components.td, {
            children: "$198"
          }), _jsx(_components.td, {
            children: "30"
          }), _jsx(_components.td, {
            children: "$6.73"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Vietnam"
          }), _jsx(_components.td, {
            children: "$24"
          }), _jsx(_components.td, {
            children: "2"
          }), _jsx(_components.td, {
            children: "$9.81"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Japan"
          }), _jsx(_components.td, {
            children: "$547"
          }), _jsx(_components.td, {
            children: "26"
          }), _jsx(_components.td, {
            children: "$20.99"
          })]
        })]
      })]
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "In an article from Common Objective CO Data  'Volume and Consumption: How Much Does The World Buy?', May 2018. Based on data 'Number of apparel units purchased per country, 2017 from Market Research Provider, Euromonitor International"
      })
    }), "\n", _jsx("strong", {
      children: "Estimated Consumer Spending in the world"
    }), "\n", _jsx(_components.p, {
      children: "Worldwide consumer spending on clothing and footwear amounts to an estimated $2,032,403.47 million dollars 2021. By 2025, that could amount to an estimated $2,571,939.42 million dollars."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Statista, July 2021."
      })
    }), "\n", _jsx("strong", {
      children: "Average Expenditure on Clothing and Footwear"
    }), "\n", _jsx(_components.p, {
      children: "US households spent 3.5% of their annual expenditures on apparel, footwear and related products in 2010 which amounts to $1700 dollar on average."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Consumer Expenditure Survey, US Bureau of Labor Statistics, published in 2012."
      })
    }), "\n", _jsx(_components.p, {
      children: "In 2020 Europeans spent 4.1% of their total household expenditure on clothing and footwear. Europeans spend on average €490 per year on their clothes."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source Eurostat &  Report Facts & Key figures 2022 of the European Textile and Clothing Industry van Euratex, June 2022. Data: EU household consumption of clothing in 2020. EUR at current prices, per capita, Eurostat"
      })
    }), "\n", _jsx("strong", {
      children: "The average wardrobe contains approximately 148 items"
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: CapsuleWardrobeData.com, based on an Instagram research in July- September 2020 with 86 respondents from  around the world."
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Yet, despite owning large quantities of fashion items, ", _jsx(_components.a, {
        href: "https://fashionunited.uk/news/fashion/people-do-not-wear-at-least-50-percent-of-their-wardrobes-according-to-study/2018081638356",
        children: "people do not wear at least 50 percent of their wardrobes"
      }), "."]
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: A study with 18,000 heads of households in 20 countries, conducted by relocation and removals company Movinga, 2018"
      })
    }), "\n", _jsx("strong", {
      children: "How much are people willing to pay for fashion?"
    }), "\n", _jsxs(_components.p, {
      children: ["What US women want to pay for their clothing\n", _jsx(_components.em, {
        children: "Prices in US dollars ($)"
      })]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Item"
          }), _jsx(_components.th, {
            children: "Mass market"
          }), _jsx(_components.th, {
            children: "Premium market"
          }), _jsx(_components.th, {
            children: "Luxe market"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Trench Coat"
          }), _jsx(_components.td, {
            children: "80-90"
          }), _jsx(_components.td, {
            children: "275-300"
          }), _jsx(_components.td, {
            children: "900-1000"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Classic White shirt"
          }), _jsx(_components.td, {
            children: "30-40"
          }), _jsx(_components.td, {
            children: "75-100"
          }), _jsx(_components.td, {
            children: "300-400"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Skinny Jeans"
          }), _jsx(_components.td, {
            children: "70-80"
          }), _jsx(_components.td, {
            children: "175-200"
          }), _jsx(_components.td, {
            children: "100-200"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Ankle boots"
          }), _jsx(_components.td, {
            children: "40-50"
          }), _jsx(_components.td, {
            children: "225-250"
          }), _jsx(_components.td, {
            children: "400-500"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Midi dress"
          }), _jsx(_components.td, {
            children: "40-50"
          }), _jsx(_components.td, {
            children: "2250-250"
          }), _jsx(_components.td, {
            children: "300-400"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Yoga Pants"
          }), _jsx(_components.td, {
            children: "40-50"
          }), _jsx(_components.td, {
            children: "75-100"
          }), _jsx(_components.td, {
            children: "75-100"
          })]
        })]
      })]
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Retail market intelligence platform Edited, 2017."
      })
    }), "\n", _jsx(_components.h2, {
      children: "E-commerce"
    }), "\n", _jsx("strong", {
      children: "General"
    }), "\n", _jsx(_components.p, {
      children: "Online shopping has been growing for years. People buy more and more via the internet."
    }), "\n", _jsx("strong", {
      children: "Revenue"
    }), "\n", _jsx(_components.p, {
      children: "In 2020 e-commerce sales globally jumped to $4.2 trillion and the global trend continued in 2021, causing online sales to culminate in an estimated 2.14 billion online shoppers worldwide, and $4.9 trillion in revenue."
    }), "\n", _jsx(_components.p, {
      children: "Global ecommerce sales are expected to reach a total $5.5 trillion worldwide in 2022. It's forecasted that the global online retail sales will exceed $7 trillion dollars by 2025."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Shopify, April 2022 & Manaferra.com Ecommerce Data 2022."
      })
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(LineChart, {
        data: ecommerceGrowthData,
        dataKey: "value",
        xAxisKey: "year",
        title: "Global E-commerce Sales Growth",
        subtitle: "Revenue in trillion dollars",
        source: "Shopify, April 2022 & Manaferra.com Ecommerce Data 2022",
        valuePrefix: "$",
        valueSuffix: "T",
        valueLabel: "E-commerce Revenue",
        color: "#8884d8"
      }), _jsx(LineChart, {
        data: ecommercePercentageData,
        dataKey: "value",
        xAxisKey: "year",
        title: "E-commerce as % of Retail Sales",
        subtitle: "Percentage of total retail sales",
        source: "Manaferra.com Ecommerce Data 2022 & Statista 2022",
        valueSuffix: "%",
        valueLabel: "Percentage of Retail",
        yDomain: [0, 30],
        color: "#82ca9d"
      })]
    }), "\n", _jsx("strong", {
      children: "Online sales: 19.6% piece of the retail pie"
    }), "\n", _jsx(_components.p, {
      children: "In 2021, e-commerce accounted for nearly 20 percent of retail sales worldwide. Forecasted is that in 2022 that share will be 21%, and in 2025 the online segment will make up close to 25% of total global retail sales."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Sources: Manaferra.com Ecommerce Data 2022 & Statista 2022 May 2022."
      })
    }), "\n", _jsx("strong", {
      children: "Global Ecommerce Sales: Largest Contributors"
    }), "\n", _jsx(_components.p, {
      children: "Countries with the highest e-commerce revenue are China, US, Japan, the UK and Germany."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Manferra  Ecommerce Data 2022 & Shopify, April 2022."
      })
    }), "\n", _jsx(_components.h2, {
      children: "E-commerce in Fashion"
    }), "\n", _jsx("strong", {
      children: "Fashion E-commerce Segment with the most users: Apparel"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://fashionunited.com/news/retail/clothing-was-top-online-segment-for-global-consumers-in-2021/2022010344818",
        children: "'Clothing' was top online segment for global consumers in 2021"
      }), " for online, both locally and cross-border. The online apparel market ", _jsx(_components.a, {
        href: "https://fashionunited.com/news/retail/clothing-was-top-online-segment-for-global-consumers-in-2021/2022010344818",
        children: "grew fas ter year on year in 2020"
      }), " amid the Covid-19 pandemic compared to the years before."]
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Global Clothing B2C E-Commerce Market report 2021, by Research and Markets, December 2021."
      })
    }), "\n", _jsx("strong", {
      children: "Revenue Global Fashion E-commerce Market: $668 billion in 2021"
    }), "\n", _jsx(_components.p, {
      children: "The Global Fashion E-Commerce Market is valued at $668.1 billion dollars in 2021."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Sources; Source: Fashion E-commerce Global Market Report 2022, Research and Markets, May  2022 &.,Statista, May 2022."
      })
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(LineChart, {
        data: fashionEcommerceData,
        dataKey: "value",
        xAxisKey: "year",
        title: "Global Fashion E-commerce Market Growth",
        subtitle: "Revenue in billion dollars",
        source: "Research and Markets, Statista (2022)",
        valuePrefix: "$",
        valueSuffix: "B",
        valueLabel: "Fashion E-commerce Revenue",
        color: "#FF8042"
      }), _jsx(PieChart, {
        data: ecommerceSegmentsData,
        dataKey: "value",
        nameKey: "name",
        title: "Fashion E-commerce Segments (2021)",
        subtitle: "Revenue in billion dollars",
        source: "Statista, April 2022",
        valuePrefix: "$",
        valueSuffix: "B",
        valueLabel: "Revenue",
        colors: ['#00C49F', '#FFBB28', '#FF8042']
      })]
    }), "\n", _jsx(_components.p, {
      children: "The accessories segment of the global e-commerce fashion market generated a revenue around $261.5 billion dollars in 2021. The footwear market had a revenue of around $122 billion dollars in 2021."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Statista, April 2022."
      })
    }), "\n", _jsx(_components.p, {
      children: "The e-commerce fashion industry is expected to grow to $744.4 billion dollars in 2022."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Fashion E-commerce Global Market Report 2022, Research and Markets, May 2022."
      })
    }), "\n", _jsx(_components.p, {
      children: "Statista estimates that the online clothing and apparel industry will reach a value of 1.2 trillion U.S. dollars by 2025, Research and Markets expects the e-commerce fashion industry will grow to $1.1 trillion dollars in 2026."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Sources; Source: Fashion E-commerce Global Market Report 2022, Research and Markets, May  2022 &.,Statista, May 2022."
      })
    }), "\n", _jsx("strong", {
      children: "The top visited websites for purchasing apparel online"
    }), "\n", _jsxs(_components.p, {
      children: ["In 2021, the ", _jsx(_components.a, {
        href: "https://fashionunited.com/news/retail/clothing-was-top-online-segment-for-global-consumers-in-2021/2022010344818",
        children: "top-visited websites for purchasing apparel online"
      }), " were reportedly Amazon and Shein. Asos also topped the popularity chart in the UK, while Target closely followed Amazon in the US. In Germany, online-only retailers Zalando and Zooplus were among the most used."]
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Global Clothing B2C E-Commerce Market report 2021, by Research and Markets, December 2021"
      })
    }), "\n", _jsx("strong", {
      children: "Online and offline share of total fashion retail sales worldwide"
    }), "\n", _jsx(_components.p, {
      children: "Of overall fashion retail sales worldwide, nearly 21 percent are online purchases."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Statista, April 2022."
      })
    }), "\n", _jsx("strong", {
      children: "Most shopping is done in-store"
    }), "\n", _jsx(_components.p, {
      children: "There are no global figures, but in the US 75 percent of all fashion purchases were pre-Covid-19 made in physical stores."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: 2018 study consulting firm Oliver Wymann, based on interviews with 1500 across the US."
      })
    }), "\n", _jsx(_components.p, {
      children: "In 2014, the global online fashion retail sales were $253 billion dollars, 14% of total fashion sales."
    }), "\n", _jsx("p", {
      children: _jsx("small", {
        children: "Source: Forrester, \"Forrester Analytics: Online Fashion Retail Forecast, 2017 To 2022 (Global)\", November 2018."
      })
    }), "\n", _jsx("em", {
      children: "Last update: July 2022."
    }), "\n", _jsx("em", {
      children: "Below you find Country facts and figures from 2018."
    }), "\n", _jsx(_components.h2, {
      children: "Country facts and figures"
    }), "\n", _jsx(_components.p, {
      children: "How many pieces of clothing are sold world wide? How many people work in the international fashion industry? What is the total sales of clothing in the world? This is the FashionUnited page with Facts and Figures about the global and US fashion industry. For facts and figures of the fashion industry in other countries and regions, see  below."
    }), "\n", _jsx(_components.p, {
      children: "The International fashion market is a leading industry well known for key players, such as Inditex, LVMH, H&M, Nike, VF Corporation, Richemont, Adidas, Fast Retailing, Abercrombie & Fitch, Prada, Gap, Dior, Urban Outfitters, Burberry."
    }), "\n", _jsxs(_components.p, {
      children: ["For the real-time market value and other stock information on these companies, refer to the ", _jsx(_components.a, {
        href: "http://fashionunited.com/i/top100",
        children: "FashionUnited Top 100"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      children: "France"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Population:"
      }), " 66.2 million\n", _jsx(_components.strong, {
        children: "Labor force:"
      }), " 30.05 million\n", _jsx(_components.strong, {
        children: "Unemployment rate:"
      }), " 9.9%\n", _jsx(_components.strong, {
        children: "GDP per capita (PPP):"
      }), " $ 42,726"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Domestic market value of fashion:"
      }), " $ 43.3 billion\n", _jsx(_components.strong, {
        children: "Employment in fashion:"
      }), " 340,000"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://fashionunited.fr/statistics/industrie-de-la-mode-habillement-statistiques-france",
        title: "Statistiques et chiffres de l'industrie de la mode en France",
        children: "Fashion Statistics: France"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Germany"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Population:"
      }), " 80.9 million\n", _jsx(_components.strong, {
        children: "Labor force:"
      }), " 42.0 million\n", _jsx(_components.strong, {
        children: "Unemployment rate:"
      }), " 5.3%\n", _jsx(_components.strong, {
        children: "GDP per capita (PPP):"
      }), " $ 47,627"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Domestic market value of fashion:"
      }), " $ 83,6 billion\n", _jsx(_components.strong, {
        children: "Employment in fashion:"
      }), " 340,000"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://fashionunited.de/statistics/zahlen-und-fakten-zur-deutschen-modeindustrie/",
        title: "Statistik der deutschen Modeindustrie",
        children: "Fashion Statistics: Germany"
      })
    }), "\n", _jsx(_components.h3, {
      children: "The Netherlands"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Population:"
      }), " 16.9 million\n", _jsx(_components.strong, {
        children: "Labor force:"
      }), " 9.0 million\n", _jsx(_components.strong, {
        children: "Unemployment rate:"
      }), " 6.9%\n", _jsx(_components.strong, {
        children: "GDP per capita (PPP):"
      }), " $ 52,139"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Domestic market value of fashion:"
      }), " $ 16.5 billion\n", _jsx(_components.strong, {
        children: "Employment in fashion:"
      }), " 87,910"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://fashionunited.nl/statistics/statistieken-modebranche-nederland",
        title: "Statistieken Modebranche Nederland",
        children: "Fashion Statistics: The Netherlands"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Spain"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Population:"
      }), " 46.8 million\n", _jsx(_components.strong, {
        children: "Labor force:"
      }), " 23.3 million\n", _jsx(_components.strong, {
        children: "Unemployment rate:"
      }), " 22.7%\n", _jsx(_components.strong, {
        children: "GDP per capita (PPP):"
      }), " $ 29,863"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Domestic market value of fashion:"
      }), " $ 31.1 billion"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "http://www.fashionunited.es/statistics/estadisticas-de-consumo-y-ventas-de-la-moda-en-espana",
        title: "Estadísticas del sector de la moda en España",
        children: "Fashion Statistics: Spain"
      })
    }), "\n", _jsx(_components.h3, {
      children: "United Kingdom"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Population:"
      }), " 64.5 million\n", _jsx(_components.strong, {
        children: "Labor force:"
      }), " 33 million\n", _jsx(_components.strong, {
        children: "Unemployment rate:"
      }), " 6.3%\n", _jsx(_components.strong, {
        children: "GDP per capita (PPP):"
      }), " $ 46,297"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Domestic market value of fashion:"
      }), " $ 94.1 billion\n", _jsx(_components.strong, {
        children: "Employment in fashion:"
      }), " 555,000"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://fashionunited.uk/statistics/uk-fashion-industry-statistics",
        title: "UK fashion industry statistics",
        children: "Fashion Statistics: United Kingdom"
      })
    }), "\n", _jsx(_components.p, {
      children: "See also:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Apparel industry statistics - ", _jsx(_components.a, {
          href: "https://fashionunited.co/estadisticas-de-la-industria-de-la-moda-en-colombia",
          title: "Estadísticas de la industria de la moda en Colombia",
          children: "Colombia"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Apparel and textiles industry facts - ", _jsx(_components.a, {
          href: "https://fashionunited.in/statistics/fashion-industry-statistics-india",
          title: "Fashion Industry Statistics India",
          children: "India"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Fashion industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/russia",
          title: "статистика индустрии моды",
          children: "Russia"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Apparel facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com.pe/estadisticas-de-la-industria-de-la-moda-en-peru",
          title: "https://fashionunited.com.pe/estadisticas-de-la-industria-de-la-moda-en-peru",
          children: "Peru"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com.ar/estadisticas-de-la-industria-de-la-moda-en-argentina",
          title: "Estadísticas de la industria de la moda en Argentina",
          children: "Argentina"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Apparel industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/china",
          title: "Fashion industry statistics China",
          children: "China"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.it/statistiche-moda-italia",
          title: "Statistiche della moda Italia",
          children: "Italy"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/japan",
          title: "Fashion statistics Japan",
          children: "Japan"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/czech-republic",
          title: "Fashion statistics Czech Republic",
          children: "Czech Republic"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/denmark",
          title: "Fashion statistics Denmark",
          children: "Denmark"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/finland",
          title: "Fashion statistics Finland",
          children: "Finland"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/hungary",
          title: "Fashion statistics Hungary",
          children: "Hungary"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/norway",
          title: "Fashion statistics Norway",
          children: "Norway"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/poland",
          title: "Fashion statistics Poland",
          children: "Poland"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/portugal",
          title: "Fashion statistics Portugal",
          children: "Portugal"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/sweden",
          title: "Fashion statistics Sweden",
          children: "Sweden"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Clothing industry facts and figures - ", _jsx(_components.a, {
          href: "https://fashionunited.com/statistics/turkey",
          title: "Fashion statistics Turkey",
          children: "Turkey"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["The fashion industry statistics pages are a product of FashionUnited Business Intelligence. For other data, such as the FashionUnited Top 100, the FashionUnited Facebook Index and the List of Richestest People in Fashion, refer to the ", _jsx(_components.a, {
        href: "http://fashionunited.com/i/top100",
        children: "FashionUnited Top 100"
      }), "."]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h3, {
      children: "Sources"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Import and export data: ", _jsx(_components.a, {
          href: "https://atlas.media.mit.edu/en/",
          children: "OEC"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Largest companies Info: ", _jsx(_components.a, {
          href: "/i/top100",
          children: "FashionUnited top 100"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Population and Labour Data: ", _jsx(_components.a, {
          href: "https://data.worldbank.org/",
          children: "World Bank"
        }), " | ", _jsx(_components.a, {
          href: "http://www.wto.org",
          children: "www.wto.org"
        })]
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://epp.eurostat.ec.europa.eu/statistics_explained/index.php/Textile,_clothing,_leather_and_shoe_production_statistics_-_NACE_Rev._1.1",
          children: "Eurostat"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.cia.gov/library/publications/the-world-factbook/index.html",
          children: "CIA"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.ilo.org",
          children: "ILO"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.wto.org",
          children: "WTO"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://www.ibisworld.com",
          children: "IBISWorld"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://www.oecd.org",
          children: "OECD"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://comtrade.un.org",
          children: "Comtrade (UN)"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://www.nycedc.com",
          children: "NYCEDC"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://www.census.gov",
          children: "US Census Bureau"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://www.jec.senate.gov/public",
          children: "JEC Democratic"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "http://www.bls.gov",
          children: "Bureau of Labor"
        })
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
